// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GlobalPopup_wrapper__1gUOi","wrapperInner":"GlobalPopup_wrapperInner__2N455","boxClose":"GlobalPopup_boxClose__1WWqC"};